import React from 'react';
import { Box, Stack } from '@mui/material';
import { motion } from 'framer-motion';

import EditorialButton from '../editorial/EditorialButton';

const containsHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str || '');

const ClassesListCard = ({ classHeading, classDetail, classId, classesImage, index = 0 }) => {
  const handleClick = () => localStorage.setItem('classId', classId);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.8, delay: (index % 4) * 0.05, ease: [0.22, 1, 0.36, 1] }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '260px 1fr auto' },
          alignItems: 'center',
          gap: { xs: 3, md: 5 },
          py: { xs: 5, md: 6 },
          borderTop: '1px solid rgba(36,34,88,0.12)',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: { xs: 220, md: 200 },
            overflow: 'hidden',
            background: 'var(--navy-700)',
          }}
        >
          <Box
            component="img"
            src={classesImage}
            alt={classHeading}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 800ms cubic-bezier(0.22,1,0.36,1)',
              '&:hover': { transform: 'scale(1.04)' },
            }}
          />
        </Box>

        <Stack spacing={2}>
          <Box
            sx={{
              fontFamily: 'var(--font-mono)',
              fontSize: 10.5,
              letterSpacing: '0.22em',
              textTransform: 'uppercase',
              color: 'var(--teal-500)',
            }}
          >
            {String(index + 1).padStart(2, '0')}  /  Class
          </Box>
          <Box
            sx={{
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: { xs: 24, md: 32 },
              lineHeight: 1.1,
              letterSpacing: '-0.01em',
              color: 'var(--navy-500)',
            }}
          >
            {classHeading}
          </Box>
          <Box
            sx={{
              fontFamily: 'var(--font-body)',
              fontSize: 16,
              lineHeight: 1.6,
              color: 'var(--text)',
              opacity: 0.82,
              maxWidth: 720,
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {containsHTML(classDetail) ? (
              <div dangerouslySetInnerHTML={{ __html: classDetail }} />
            ) : (
              classDetail
            )}
          </Box>
        </Stack>

        <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
          <EditorialButton variant="ghost" onClick={handleClick} href={`/class-detail/${classId}`}>
            View Details
          </EditorialButton>
        </Box>
      </Box>
    </motion.div>
  );
};

export default ClassesListCard;
